
// use for log in
export class Letters {
    id: number;
    approvedLetter: string;
    pendingApprovedLetter: string;
    unapprovedLetter: string;
}